import { defineComponent as _defineComponent } from 'vue'
import { computed, type PropType } from 'vue'
import {
  membershipRoleChipClasses,
  normalizeMembershipRoleKey,
} from '~/functions/membership-role'
import type { AccountMembershipRole } from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'MembershipRole',
  props: {
  role: {
    type: String as PropType<AccountMembershipRole | string>,
  },
},
  setup(__props) {

const props = __props;



const roleKey = computed(() => normalizeMembershipRoleKey(props.role))

return { __sfc: true,props, roleKey, membershipRoleChipClasses }
}

})